import * as React from 'react';
import { Create, Form, Toolbar } from 'react-admin';
import { Card, CardContent } from '@mui/material';

import { AntennaInputs } from './AntennaInputs';

export const AntennaCreate = () => {
    return (
        <Create
            actions={false}
            redirect="show"
            transform={values => {
                // add https:// before website if not present
                if (values.website && !values.website.startsWith('http')) {
                    values.website = `https://${values.website}`;
                }
                return values;
            }}
        >
            <Form>
                <Card>
                    <CardContent>
                        <AntennaInputs />
                    </CardContent>
                    <Toolbar />
                </Card>
            </Form>
        </Create>
    );
};
